<template>
  <div class="range-input" v-byted-clickoutside="clickOutsideHandler">
    <!-- 伪输入 -->
    <div :class="[{'fake-input-active': isRangePanelShow}, 'fake-input']" @click="fakeInputClickHandler">
      <div class="fake-input-placeholder" v-if="!rangeValueString">{{$bp_t('请选择', 'common.please_choose')}}</div>
      <div class="fake-input-value" v-else>{{rangeValueString}}</div>
      <byted-icon name="angle-down" color="#999" :class="{'deg-180': isRangePanelShow}"></byted-icon>
    </div>
    <!-- 实际输入面板 -->
    <div class="range-panel" v-if="isRangePanelShow">
      <!-- 类型选择区域 -->
      <div class="range-type-area">
        <div
          v-for="item in rangeTypeItemList"
          :key="item.type"
          @click="rangeTypeItemClickHandler(item.type)"
          class="range-type-item"
          :style="{color: getRangeTypeItemColor(item.type)}"
        >
          <span>{{item.label}}</span>
          <byted-icon name="angle-right" :color="getRangeTypeItemColor(item.type)"></byted-icon>
        </div>
      </div>
      <!-- 输入区 -->
      <div class="range-input-area" v-if="isRangeInputShow">
        <!-- 实际输入 -->
        <div :class="['actual-input', {'error': inputErrorTip}]">
          <byted-input clearable v-model="inputRangeValue" :placeholder="$bp_t('请输入数值', 'bp.ad_please_enter_a_value')"></byted-input>
          <span>{{value.unit}}</span>
        </div>
        <!-- 校验错误提示 -->
        <div class="error-tip" v-if="inputErrorTip">{{inputErrorTip}}</div>
        <!-- 应用btn -->
        <div class="apply-btn-area">
          <byted-button
            type="primary"
            @click="applyBtnClickHandler"
          >{{ $bp_t('应用', 'common.application') }}</byted-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const rangeTypeConfigMap = {
  st: { type: 'st', label: $bp_t('大于', 'common.greater_than') },
  et: { type: 'et', label: $bp_t('小于', 'common.less_than') },
  // 等于
  // 大于等于
  // 小于等于
}

export default {
  name: 'range-input',
  props: {
    value: {
      type: Object,
      default: () => ({
        st: '',
        et: '',
        unit: '',
      })
    },
    rangeTypeList: {
      type: Array,
      default: () => ['st', 'et']
    },
    customValidation: {
      type: Function
    }
  },
  data() {
    return {
      isRangePanelShow: false,
      isRangeInputShow: false,
      selectedRangeType: '',
      inputRangeValue: '',
      inputErrorTip: '',
    }
  },
  computed: {
    rangeValueString() {
      const { value } = this;
      let curType = ''
      for (let type of this.rangeTypeList) {
        curType = value[type] ? type : curType;
      }
      return curType === '' ? '' : `${rangeTypeConfigMap[curType].label} ${value[curType]} ${value.unit}`;
    },
    rangeTypeItemList() {
      const list = [];
      this.rangeTypeList.map((type) => {
        list.push(rangeTypeConfigMap[type])
      })
      return list;
    }
  },
  watch: {
    inputRangeValue() {
      this.inputErrorTip = this.inputValid();
    }
  },
  methods: {
    initData() {
      this.inputRangeValue = '';
      this.inputErrorTip = '';
      for (let type of this.rangeTypeList) {
          this.selectedRangeType = this.value[type] ? type : this.selectedRangeType;
      }
      this.inputRangeValue = this.value[this.selectedRangeType] || '';
      this.isRangeInputShow = !!this.inputRangeValue;
    },
    clickOutsideHandler() {
      // 点击input外面时
      this.isRangePanelShow = false;
    },
    fakeInputClickHandler() {
      // 数据的设置
      this.initData();
      // 控制panel的展开关闭
      this.isRangePanelShow = !this.isRangePanelShow;
    },
    rangeTypeItemClickHandler(rangeType) {
      this.selectedRangeType = rangeType;
      this.isRangeInputShow = true;
    },
    getRangeTypeItemColor(rangeType) {
      return this.selectedRangeType === rangeType ? '#2F88FF' : '#333'
    },
    inputValid() {
      // 自定义校验
      if (this.customValidation && !this.customValidation(this.inputRangeValue)[0]) {
        return this.customValidation(this.inputRangeValue)[1]
      } else if (this.customValidation) {
        return ''
      } // else -> customValidation为undefined时，走默认的校验逻辑
      if (!this.inputRangeValue) {
        return "";
      }
      let tmpNumber = Number(this.inputRangeValue);
      if (this.value.isInt) {
        let reg = /^(0|[1-9][0-9]*)$/;
        if (!reg.test(this.inputRangeValue)) {
          return $bp_t(
            "请输入合法非负整数",
            "bp.ad_report_reporter_input_negative_integer"
          );
        }
      } else {
        if (
          isNaN(this.inputRangeValue) ||
          tmpNumber < 0 ||
          (tmpNumber >= 1 && this.inputRangeValue[0] === "0")
        ) {
          return $bp_t(
            "请输入合法非负数值",
            "bp.ad_report_reporter_input_negative_value"
          );
        }
        let reg = /^([0-9])+(.[0-9]{1,2})?$/;
        if (!reg.test(this.inputRangeValue)) {
          return $bp_t("小数最多支持2位", "bp.ad_report_reporter_decimal_two");
        }
        if (tmpNumber > 999999999.99) {
          return $bp_t(
            "最高值不能超过999999999.99",
            "bp.ad_report_reporter_maximum_exceed",
            { data: 999999999.99 }
          );
        }
      }
      return "";
    },
    applyBtnClickHandler() {
      this.inputErrorTip = this.inputValid();
      if (this.inputErrorTip) {
        return;
      }
      this.isRangePanelShow = false;
      const changedValue = JSON.parse(JSON.stringify(this.value))
      this.rangeTypeList.map((type) => {
        changedValue[type] = '';
      })
      changedValue[this.selectedRangeType] = this.inputRangeValue;
      this.$emit("valueChanged", changedValue)
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/basic/theme.scss";

.range-input {
  width: 210px;
  height: 34px;
  position: relative;

  .fake-input {
    height: 34px;
    width: 210px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 6px 12px;
    cursor: pointer;
    font-size: 14px;
    line-height: 20px;
    position: relative;

    .fake-input-placeholder {
      color: $color-text-holder;
    }

    .fake-input-value {
      color: $color-border-underline;
      width: 150px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .byted-icon {
      position: absolute;
      right: 8px;
      top: 50%;
      transform: translateY(-50%);
      height: 14px;
      width: 18px;
      transition-duration: 0.2s;
      cursor: pointer;
    }

    .deg-180 {
      transform: rotate(180deg) translateY(50%);
      transition-duration: 0.2s;
    }

    &:hover {
      border-color: #2f88ff;
    }

    &.fake-input-active {
      border-color: #2f88ff;
      box-shadow: 0 0 0 2px rgba(47, 136, 255, 0.2);
    }
  }

  .range-panel {
    height: 200px;
    background-color: $color-bg-container;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
    border-radius: 0px 0px 2px 2px;
    z-index: 10;
    position: absolute;
    top: 34px;
    left: 1px;
    display: -webkit-flex;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;

    .range-type-area {
      width: 100px;
      height: 200px;
      float: left;
      border-right: $color-border-block 1px solid;

      .range-type-item {
        font-size: 14px;
        line-height: 38px;
        cursor: pointer;
        padding: 0 12px;
        color: $color-text-main;

        &:hover {
          color: $color-border-active;
        }

        .byted-icon {
          height: 14px;
          width: 14px;
          float: right;
          margin-top: 12px;
        }
      }
    }

    .range-input-area {
      padding: 12px;
      width: 164px;
      height: 200px;
      float: left;

      .actual-input {
        line-height: 34px;
        font-size: 12px;
        height: 34px;

        .byted-input {
          width: 120px;
          float: left;
          margin-right: 5px;
        }

        &.error .byted-input /deep/ input {
          border: $color-border-hint 1px solid;
          &:focus {
            box-shadow: 0 0 0 2px rgba(244, 88, 88, 0.2);
          }
        }
      }

      .error-tip {
        font-size: 12px;
        color: $color-border-hint;
        line-height: 22px;
        margin-top: 4px;
      }

      .apply-btn-area {
        position: absolute;
        bottom: 12px;
        right: 12px;

        .byted-button {
          padding: 0;
          margin: 0;
          min-width: 60px;
          height: 26px;
          line-height: 24px;
          text-align: center;
          font-size: 12px;
        }
      }
    }
  }
}

html {
  &:lang(en) {
    // 英文样式修复
    .range-input {
      .range-panel {
        .range-type-area {
          width: 136px;
        }
        .range-input-area {
          .actual-input {
            .byted-input {
              width: 100px;
            }
          }
          .apply-btn-area {
            .byted-button {
              min-width: auto;
              padding: 0 12px;
            }
          }
        }
      }
    }
  }
}
</style>
